import Box from '~/common/components/Box';
import Stack from '~/common/components/Stacks/Stack';
import Text from '~/common/components/Texts/Text';
import type { RecentRaiseData } from '~/pages/IncomeCalculator/Pages/ReviewBreakdown/RecentRaise/types';

type FormulaDisplayProps = {
  calculationFormula: RecentRaiseData['calculationFormula'];
  incomeYear: string;
  isLpaRecentRaise?: boolean;
};

export default function FormulaDisplay({
  calculationFormula,
  incomeYear,
  isLpaRecentRaise = false,
}: Readonly<FormulaDisplayProps>) {
  if (!calculationFormula || calculationFormula.length === 0) {
    return null;
  }

  const getHeaderTitle = (sortOrder: number) => {
    if (sortOrder === 1) return 'Hours at Prior Rate';
    if (sortOrder === 2) return 'Hours at Current Rate';
    if (sortOrder === 3) {
      if (incomeYear === 'Ytd') {
        return 'YTD Total Hours';
      }

      return isLpaRecentRaise
        ? "Last Year's Total Hours"
        : "Last Year's Hours Needed";
    }
    if (sortOrder === 4) {
      return incomeYear === 'Ytd'
        ? 'YTD Monthly Hours'
        : "Last Year's Monthly Hours";
    }
    return null;
  };

  return (
    <Box fontSize="xs" mt={4}>
      <Stack spacing={2}>
        {calculationFormula.map((item) => (
          <Box as="li" key={`${item.formulaId}`} listStyleType="none" mb={3}>
            {getHeaderTitle(item.sortOrder) && (
              <Text fontSize="md" fontWeight="bold" mb={2}>
                {getHeaderTitle(item.sortOrder)}
              </Text>
            )}
            <Text fontSize="md" mb={1} color="gray.600">
              = {item.formulaName}
            </Text>
            <Text fontSize="md" color="gray.600">
              = {item.formula}
            </Text>
            {item.formulaHours && (
              <Text fontSize="md" color="black" mt={1}>
                = {item.formulaHours}
              </Text>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
